// 官网域名：hotel.xinjingtech.net
// 管理平台域名：cloud.hotel.xinjingtech.net
// 内部管理后台： hotel.internal.xinjngtech.com
// 后台预发布环境：pre.xinjngtech.com
// 内部后台预发布环境：pre.internal.xinjngtech.com
// 测试官网域名：test.xinjngtech.com

let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1
switch (domain) {
  case 'crm.xinjingtech.net':
    base = 'https://crm.xinjingtech.net/' //正式crm
    break;
  case 'pre.crm.xinjngtech.com':
    base = 'https://pre.crm.xinjngtech.com/' //预发布crm
    break;
  case 'dev.crm.xinjngtech.com':
    base = 'https://dev.crm.xinjngtech.com/' //开发crm
    break;
  case 'test.crm.xinjngtech.com':
    base = 'https://test.crm.xinjngtech.com/' //测试crm
    break;
  default:
    if (hotelType) {
      console.log(hotelType, 'url--------')
      base = 'https://test.crm.xinjngtech.com/'
      // base = 'https://dev.crm.xinjngtech.com/'
    } else {
      base = location.protocol + '//' + location.host + '/';
    }
    break;

}
export default base;



// WEBPACK FOOTER //
// ./src/api/baseUrl.js